// extracted by mini-css-extract-plugin
export default {"quizCreator":"QuizCreator_quizCreator__Q58Co","selectOptionContainer":"QuizCreator_selectOptionContainer__yiluA","quizCreatorBtn":"QuizCreator_quizCreatorBtn__UGLJh"};